var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EContractCostsAreIndexable } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { EAdditionalCostField } from "./AdditionalCost.types";
export var getAdditionalCostsKey = function (index) {
    return "additional-costs-".concat(index);
};
export var getFieldKey = function (_a) {
    var sectionKey = _a.sectionKey, fieldKey = _a.fieldKey;
    return "".concat(sectionKey, "-").concat(fieldKey);
};
export var getValue = function (_a) {
    var _b, _c;
    var sectionKey = _a.sectionKey, fieldKey = _a.fieldKey, formData = _a.formData;
    return (_c = (_b = formData === null || formData === void 0 ? void 0 : formData[sectionKey]) === null || _b === void 0 ? void 0 : _b[fieldKey]) !== null && _c !== void 0 ? _c : "";
};
export var getInitialCount = function (formData, name) {
    return (formData === null || formData === void 0 ? void 0 : formData[name]) ? Object.keys(formData[name]).length : 0;
};
export var getInitialCost = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.StartPrice,
        formData: formData,
    });
};
export var getInitialDescription = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.Description,
        formData: formData,
    });
};
export var indexationToggleValueSetInInitialCosts = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.IsIndexable,
        formData: formData,
    });
};
export var mapStartToCurrentPriceIfNotIndexable = function (_a) {
    var _b = _a.formData, formData = _b === void 0 ? {} : _b;
    var updatedFormData = {};
    Object.keys(formData).forEach(function (key) {
        var _a;
        var item = formData[key];
        if (item[EAdditionalCostField.IsIndexable] === EContractCostsAreIndexable.Yes) {
            updatedFormData[key] = item;
            return;
        }
        updatedFormData[key] = __assign(__assign({}, item), (_a = {}, _a[EAdditionalCostField.CurrentPrice] = item[EAdditionalCostField.StartPrice]
            ? item[EAdditionalCostField.StartPrice]
            : item[EAdditionalCostField.CurrentPrice], _a));
    });
    return updatedFormData;
};
